import {t} from 'i18next';
import {getMonthYearFormatFromDate, formatWeddingOccasionTime} from '../helpers';
import {WeddingOccasionDB} from '../lib/interfaces';
import {BookingState} from '../store';
import {UaLink, UaRadioButton, UaSpinner} from 'uppsala.ui.react';

interface AvailableTimesProps {
  bookingState: BookingState;
  availableDateMonths: string[];
  availableOccasions: WeddingOccasionDB[];
  loading: boolean;
  onMonthYearSelected: (value: string) => void;
  onSelectedOccasionId: (weddingOccasionId: string) => void;
}

const AvailableTimes = (props: AvailableTimesProps) => {
  return (
    <div style={{maxWidth: '800px'}}>
      <span style={{wordBreak: 'break-word'}}>
        {t('booking.selectAvailableWeddingOccasionInfo')}{' '}
        <UaLink
          text={t('booking.linkTextToBorgerligVigsel')}
          link={'https://www.uppsala.se/stod-och-omsorg/vigsel-och-begravning/borgerlig-vigsel/'}
          target="_blank"
        />
      </span>

      <div style={{marginTop: '30px'}} />

      <h2>{t('booking.header.book')}</h2>

      {props.loading && (
        <div className="flex-row">
          <UaSpinner title={t('status.fetchingStartDates') ?? ''} />
        </div>
      )}

      {!props.loading && (
        <>
          <h3>{t('booking.header.chooseMonthForOccasion')}</h3>

          <div style={{margin: '30px 0'}}>
            {props.availableDateMonths.map((value) => (
              <UaRadioButton
                id={value}
                value={value}
                key={value}
                label={getMonthYearFormatFromDate(value)}
                selected={value === props.bookingState.selectedMonthYear}
                name={'selectBookingTime'}
                onChange={props.onMonthYearSelected}
                className="mb-3"
              />
            ))}
          </div>

          {props.bookingState.selectedMonthYear && (
            <>
              <h3>
                {t('booking.availableTimeSlots')}{' '}
                {getMonthYearFormatFromDate(props.bookingState.selectedMonthYear).toLocaleLowerCase()}
              </h3>
              <div style={{margin: '30px 0'}} key={props.bookingState.selectedMonthYear}>
                {props.availableOccasions.map((item) => (
                  <UaRadioButton
                    className="mb-3"
                    id={item.id}
                    value={item.id}
                    key={item.time.toString()}
                    label={formatWeddingOccasionTime(item.time, item.weddingOfficiant.name)}
                    selected={item.id === props.bookingState.weddingOccasionId}
                    name={'selectAvailableWeddingOccasion'}
                    onChange={props.onSelectedOccasionId}
                  />
                ))}
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default AvailableTimes;
